import { isInFuture } from '../../../utils';
import { getAmendments } from './Datatables/services/ContractTeam.service';

const getEditFlags = amendments => {
	const MARKING_METHOD_CHANGED = 'Change of marking method';
	const MARKING_TEMPLATE_CHANGED = 'Change of marking type';
	const noEdit = {
		markingMethodEdit: false,
		markingTemplateEdit: false
	};

	if (amendments.length === 0) {
		return noEdit;
	}
	const futureAmendment = amendments.filter(amendment => isInFuture(amendment.amendmentDate));
	if (futureAmendment.length === 0) {
		return noEdit;
	}

	const markingMethodEdit = futureAmendment[0].amendmentReasons.includes(MARKING_METHOD_CHANGED);
	const markingTemplateEdit = futureAmendment[0].amendmentReasons.includes(MARKING_TEMPLATE_CHANGED);
	return {
		markingMethodEdit,
		markingTemplateEdit
	};
};

export const getEditStatus = async team => {
	const { id_type, markingTeamId, type, currentYear } = team;
	const { amendments, errors } = await getAmendments(currentYear, markingTeamId, type);
	if (errors.length > 0) {
		throw new Error(`Error getting Amendments for markingTeamId ${markingTeamId}`);
	}
	const { markingMethodEdit, markingTemplateEdit } = getEditFlags(amendments);
	return {
		id_type,
		markingMethodEdit,
		markingTemplateEdit
	};
};

export const getLockedRows = teamsEditStatuses => {
	return teamsEditStatuses.filter(status => !status.markingMethodEdit && !status.markingTemplateEdit).map(status => status.id_type);
};

export const getEditStatuses = teamsEditStatuses => {
	return teamsEditStatuses
		.filter(status => status.markingMethodEdit || status.markingTemplateEdit)
		.reduce((editStatuses, status) => {
			const { id_type, markingMethodEdit, markingTemplateEdit } = status;
			editStatuses[id_type] = { markingMethodEdit, markingTemplateEdit };
			return editStatuses;
		}, {});
};

export const getEditableTeams = editStatuses => Object.keys(editStatuses);
